// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useEffect, useState } from "react"
import { IonSkeletonText } from "@ionic/react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  //faChevronsLeft, faChevronsRight, faChevronDown, faChevronUp, IconDefinition
  faChevronDown, faChevronUp, faExpand, IconDefinition
} from '@fortawesome/free-solid-svg-icons'
import useLocalState from './useLocalState'
import useSession from "./useSession"
import useWindowDimensions from "./useWindowDimensions"
import './SectionMenu.scss'


export interface SectionMenuProps {
  children?: React.ReactNode
  title: string | React.ReactElement
  icon: IconDefinition
}


const SectionMenu: React.FC<SectionMenuProps> = ({children, ...props}) => {
  const {ready} = useSession()
  const {width} = useWindowDimensions()
  const [isHovering, setIsHovering] = useState<boolean>(false)
  const [expandMenu, setExpandMenu] = useLocalState<boolean>(
    "section-context-menu-expand", (width >= 1024)
  )
  const [visible, setVisible] = useState<boolean>(false)
  const classes: string[] = ["section-menu"]
  if (expandMenu) {
    classes.push("expand")
  }
  if (visible) {
    classes.push("visible")
  }

  useEffect(() => {
    if (!expandMenu) {
      setIsHovering(false)
    }
  }, [expandMenu])

  return (
    <div className={classes.join(" ")} onClick={() => setIsHovering(false)}>
      <aside
        className={(!!isHovering) ? "expand-on-hover": ""}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <div className="header" onClick={() => {
          if (width > 768) {
            return
          }
          setVisible(!visible)
        }}>
          <div className="icon">
            <FontAwesomeIcon icon={props.icon} size="xl"/>
          </div>
          <div className="title">
            {(!!ready) ? props.title : (<IonSkeletonText animated={true}/>)}
          </div>
          <div className="icon-expand">
            <FontAwesomeIcon icon={(!visible) ? faChevronDown : faChevronUp}/>
          </div>
        </div>
        <div className="items" onClick={() => setVisible(false)}>{children}</div>
        <div className="footer">
          <div
            className="menu-item"
            id="section-menu-pin-button"
            onClick={() => setExpandMenu(!expandMenu)}
            onMouseEnter={() => {
              if (!expandMenu) {
                setIsHovering(true)
              }
            }}
          >
            <div className="icon">
              <FontAwesomeIcon icon={faExpand}/>
            </div>
          </div>
        </div>
      </aside>
    </div>
  )
}


export default SectionMenu